import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {ModalService} from '@app/core/services/modal.service';
import {AuthService, UserRole} from '@app/core/auth/auth.service';
import {ModaldsgvoComponent} from '@app/shared/modals/modaldsgvo/modaldsgvo.component';
import {ModalButton, ModalButtons, ModalCloseReason} from '@app/core/models/modal-ref';
import {DeviceService} from '@app/core/services/device.service';
import {take} from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class DsgvoService {

  constructor(private http: HttpClient,
              private log: NGXLogger,
              private modal: ModalService,
              private auth: AuthService,
              private device: DeviceService) {

  }

  public init() {
    this.device.onDeviceSwitch
      .pipe(take(1))
      .subscribe(() => {
        if (this.auth.role !== UserRole.Default) {
          return;
        }

        this.checkDsgvo();
      });
  }

  public checkDsgvo() {
    this.getDsgvo().subscribe((response => {
      this.log.info('logged in - DSGVO response=', response);
      if ((response as any).result === false) {

        const modalRef = this.modal.show({
          content: ModaldsgvoComponent,
          title: 'LICENCE.PRIVACY',
          buttons: ModalButtons.OkCancel,
          defaultButton: ModalButton.Ok
        });

        modalRef.onClose
          .subscribe(reason => {
            if (reason === ModalCloseReason.Ok) {
              this.setDsgvo().subscribe();    // no matter if it fails
            }
          });
      }
    }));
  }

  public getDsgvo() {
    return this.http.get<{result: boolean}>(environment.apiUrl + 'service/getdsgvo');
  }

  public setDsgvo() {
    // Is a get request but sets the current IP and timestamp in AAA Login table in backend, returns 200
    return this.http.get<{result: boolean}>(environment.apiUrl + 'service/setdsgvo');
  }


}
